module.exports = __webpack_public_path__ + "static/haiku-cli.4a097e18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/features/haiku-cli.jpg
// module id = 996
// module chunks = 72138227098318